module.exports = __webpack_public_path__ + "static/media/card_0.d8111833.png";